import { render, staticRenderFns } from "./summerdrink.vue?vue&type=template&id=09a5c1ca&"
import script from "./summerdrink.vue?vue&type=script&lang=js&"
export * from "./summerdrink.vue?vue&type=script&lang=js&"
import style0 from "./summerdrink.vue?vue&type=style&index=0&id=09a5c1ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports